import React from 'react';
import { StyledActionButton } from 'components/Buttons/styled-component';
import { CoreButtonProps } from 'components/Buttons/CoreButton';

export interface ActionButtonProps extends CoreButtonProps {}

const ActionButton: React.FC<ActionButtonProps> = (props): JSX.Element => {
  return (
    <StyledActionButton
      id="action-button-style"
      titleclass="action-button-title"
      {...props}
    />
  );
};

export default ActionButton;
